import { render, staticRenderFns } from "./ColorControls.vue?vue&type=template&id=2daa442a&scoped=true&"
import script from "./ColorControls.vue?vue&type=script&lang=js&"
export * from "./ColorControls.vue?vue&type=script&lang=js&"
import style0 from "./ColorControls.vue?vue&type=style&index=0&id=2daa442a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa442a",
  null
  
)

export default component.exports